














































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { Watch, Prop } from 'vue-property-decorator';
import Endpoint from '@/utils/endpoint';

import { AuthService } from '../../services/authService';
import SolicitationId from '@/@types/solicitationId';
import FeedbackInterface from '@/@types/feedback';

import ErrorResponse from '@/@types/ErrorResponse';

import qs from 'qs';

const namespace = 'add';

export type VForm = Vue & { validate: () => boolean } & {
  resetValidation: () => boolean;
};

@Component({})
export default class modalDeny extends Vue {
  @Getter('getSolicitationId', { namespace: 'auth' })
  public solicitation!: SolicitationId;

  @Getter('getModalExported', { namespace: 'auth' })
  public modalExported!: boolean;
  @Action('setModalExported', { namespace: 'auth' })
  public setModalExported!: any;

  @Getter('getFeedback', { namespace: 'auth' })
  public feedback!: FeedbackInterface;
  @Action('setFeedback', { namespace: 'auth' }) public setFeedback: any;

  @Getter('getUserLanguage', { namespace: 'auth' }) public userLanguage!: any;
  @Action('setUserLanguage', { namespace: 'auth' }) public setUserLanguage: any;

  loading = false;

  private endpoint = new Endpoint();
  authService = new AuthService();

  async exportedSolicitation() {
    const token = await this.authService.getTokenForMenuAsync();
    try {
      const params = {
        paymentrequestid: this.solicitation,
      };
      this.loading = true;
      await this.$http.put(
        this.endpoint.setExported + `/${this.solicitation}`,
        params,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      this.loading = false;
      this.closeModal();

      this.setFeedback({
        feedback: true,
        color: 'green',
        text:
          this.userLanguage === 'en'
            ? 'Status exported update'
            : 'Solicitação modificada para exportada.',
      });
      setTimeout((): void => {
        this.setFeedback({
          feedback: false,
        });
      }, 5000);

      this.$router.push({ path: '/requests' });
    } catch (error) {
      const errorData = error as ErrorResponse;
      console.log('Error ', errorData.response.data);
      this.loading = false;
      this.closeModal();

      this.setFeedback({
        feedback: true,
        color: 'red',
        text:
          errorData.response.status !== 400 ||
          errorData.response.data ===
            'Object reference not set to an instance of an object'
            ? 'Ocorreu um erro'
            : `${errorData.response.data}`,
      });
      setTimeout((): void => {
        this.setFeedback({
          feedback: false,
        });
      }, 4000);
    }
  }

  closeModal(): void {
    this.setModalExported(false);
  }
}
